const FIRST_PAGE_DEFAULT = 1;
const INCREMENT_PAGE_NUMBER = 1;
const VIEWPORT_HEIGHTS_AWAY_FROM_BOTTOM = 3;

document.addEventListener('DOMContentLoaded', () => {
	initializeReverseInfiniteScroll();

});

// Function to check if the user has scrolled X viewports away from the bottom of the results section
function isViewportHeightsAwayFromBottom() {
	const section = document.getElementById('searchResults');
	if (!section) {
		return false;
	}
	const sectionBottom = section.offsetTop + section.offsetHeight;
	return (
		sectionBottom - (window.innerHeight + window.scrollY) <=
		VIEWPORT_HEIGHTS_AWAY_FROM_BOTTOM * window.innerHeight
	);
}

function createInfiniteScrolling(results) {
	if (results.page >= results.pageCount) {
		return;
	}
	window.addEventListener('scroll', scrollHandler);
}

function scrollHandler() {
	if (isViewportHeightsAwayFromBottom()) {
		window.removeEventListener('scroll', scrollHandler);
		let pageNumber = Number(getUrlParam('page')) || FIRST_PAGE_DEFAULT;
		setUrlParam('page', (pageNumber += INCREMENT_PAGE_NUMBER));
	}
}

function initializeReverseInfiniteScroll(){
    const triggerElement = document.getElementById('header-spacer');
	const lastViewedProduct  = JSON.parse(sessionStorage.getItem('lastViewedProduct'));
	const urlPage = getUrlParam('page');
	let page = Number(lastViewedProduct?.page) || urlPage || 1;
	let isInitialRender = true;
	sessionStorage.setItem('isInitialRender', isInitialRender);
	
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
					if (isInitialRender && lastViewedProduct && page > 1){
						sessionStorage.setItem('initialReverseScrollPageNumber', page - 1);
						initPage();
						sessionStorage.setItem('isInitialRender', false);
					}
					if (page > 0){
						sessionStorage.setItem('reverseScrollPageNumber', page);
						initPage();
						page = page -1;
					}
					isInitialRender = false;
                }
            });
        },
        {
            root: null, 
            rootMargin: window.innerWidth > 1023 ? `${5000}px 0px 0px 0px` : `${3000}px 0px 0px 0px` ,
            threshold: 0,
        }
    );
    observer.observe(triggerElement);
}

function handleReverseScrollPageNumber(page){
	const reverseScrollPageNumber = Number(sessionStorage.getItem('reverseScrollPageNumber')) || false;
	if (reverseScrollPageNumber){
		page = reverseScrollPageNumber
	}

	const lastViewedProduct = JSON.parse(sessionStorage.getItem('lastViewedProduct'));
	const isInitialRender = sessionStorage.getItem('isInitialRender') === 'true'
	const initialReverseScrollPageNumber = sessionStorage.getItem('initialReverseScrollPageNumber');
	
	if (initialReverseScrollPageNumber && isInitialRender){
		page = initialReverseScrollPageNumber;
		sessionStorage.getItem('initialReverseScrollPageNumber')
	}
	else if (lastViewedProduct && lastViewedProduct?.page && !isInitialRender){
		page = lastViewedProduct?.page;		
		url.searchParams.set('page', page);
	}
	sessionStorage.setItem('currentFeedPage', page)
	return page;
}
